<a [href]="post?.url">
	<figure>
		<img [src]="post?.imageUrl" />
		<figcaption>
			<h2>{{ post?.title }}</h2>
			<p>{{ post?.excerpt | truncate: 100 : "..." }}</p>
		</figcaption>
	</figure>
</a>
